/**
 * 描述：监测跟踪左侧导航工具
 * 日期：2019-06-22
 * 作者：Qian.qianchen
 */
"use strict";
angular.module("trackLeftToolsModule", [])
    .directive("trackLeftTools", ["$compile", "$timeout", function($compile, $timeout) {
        return {
            restrict: 'A',
            replace: false,
            template: '',
            transclude: false,
            scope: false,
            link: function(scope, $elem, $attrs) {
                var top, //顶部距离
                    $template, //模板
                    myTimeout; //延时器
                // utilBtns; //可见性
                // scope.platform = $attrs["platform"]; // 所属平台
                init();
                /**
                 * [init description] 初始化
                 * @return {[type]} [description]
                 */
                function init() {
                    bindMouseEnter();
                    bindMouseLeave();
                    initDestroy();
                }
                /**
                 * [initDestroy description] 初始化监听销毁事件
                 * @return {[type]} [description]
                 */
                function initDestroy() {
                    scope.$on("$destroy", function() {
                        $(".trackQuickOperate_wrap").remove();
                    });
                }
                /**
                 * [initTemplate description] 初始化模板
                 * @return {[type]} [description]
                 */
                function initTemplate() {
                    let template = `<div class="trackQuickOperate_wrap">
                        <ul class="operation_list">
                            <li class="operation_item" ng-click="editTrack(nav)">
                                <span class="iconfont icon-tubiao09"></span>
                                编辑
                            </li>
                            <li class="operation_item" ng-click="deleteTrack(nav)">
                                <span class="iconfont icon-UGC-shanchu"></span>
                                删除
                            </li>
                        </ul>
                    </div>`;
                    return $(template);
                }
                /**
                 * [bindMouseEnter description] 绑定鼠标移入事件
                 * @return {[type]} [description]
                 */
                function bindMouseEnter() {
                    $elem.bind("mouseenter", function() {
                        $template = initTemplate();
                        $template.css({ "top": $elem.offset().top - 65, display: "block", "left": $elem.offset().left - 60 });

                        $template.bind("mouseenter", function() {
                            clearTimeout(myTimeout);
                        });
                        $template.bind("mouseleave", function() {
                            $template.remove();
                            // $('div[role="tooltip"]').remove();
                        });
                        $template.find(".operation_item").click(function() {
                            // $("div[role='tooltip']").remove();
                            $template.remove();
                        });
                        $template = $compile($template)(scope);
                        $("body").append($template);
                    });
                }
                /**
                 * [bindMouseLeave description] 绑定鼠标离开事件
                 * @return {[type]} [description]
                 */
                function bindMouseLeave() {
                    $elem.bind("mouseleave", function() {
                        myTimeout = setTimeout(function() {
                            $template.remove();
                        });
                    });
                }
            }
        };
    }]);